import { Paper, Typography, Chip, Button, Avatar } from "@mui/material";

import React from "react";
import SvgIconStyle from "../../components/SvgIconStyle";

import { useSelector, useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

import { setDashboardTab, setSelectedDonation } from "./slice";
import { ComponentType } from "../../common/enum";
import { dashboardMenu } from "../../data";
import DonationDrawer from "../Donations/DonationDrawer";

const dateOptions = { month: "long", day: "numeric", year: "numeric" };
// const categories = [ "fresh", "readyMeals"]

const DonationList = ({ item, component, t }) => {
  const [drawerState, setDrawerState] = React.useState(false);
  const {
    dashboardInfo: {
      selectedDonation: { donation },
    },
  } = useSelector((state) => state);

  const myCategory = React.useMemo(() => {
    const payload = new Set();
    item.donationProducts.forEach((product) => {
      payload.add(
        product.productType ? product.productType : product.productGroup
      );
    });
    return Array.from(payload);
  }, [item]);

  const DONATION_PRODUCT_WIDTH_HEIGHT = React.useMemo(() => {
    if (item.donationProducts.length >= 4) {
      return { width: "50%", height: "50%" };
    } else if (item.donationProducts.length === 3) {
      return {
        width: "50%",
        height: "50%",
      };
    } else if (item.donationProducts.length === 2) {
      return { width: "50%", height: "100%" };
    } else {
      return { width: "100%", height: "100%" };
    }
  }, [item]);

  const dispatch = useDispatch();

  const toggleDrawer = React.useCallback((value) => {
    setDrawerState(value);
  }, []);

  const handleClick = React.useCallback(() => {
    setDrawerState(true);
  }, []);

  

  return (
    <>
      <Paper
        sx={{
          padding: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border:
            component !== ComponentType.DASHBOARD_STATS
              ? donation?.donationId === item?.donation.donationId &&
                "2px solid #198754"
              : "",
        }}
        variant="outlined"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="div"
            sx={{
              width: "88px",
              height: "88px",
              lineHeight: "0",
              borderRadius: "50%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {item.donationProducts.length > 0 &&
              item.donationProducts.map((p, index) => {
                return (
                  <React.Fragment key={p.productId}>
                    {index < 4 && item.donationProducts.length <= 4 && (
                      <img
                        src={
                          index === 3 && item.donationProducts.length > 4
                            ? ""
                            : `/static/products/${p.productId}.jpg`
                        }
                        style={
                          index === 2 && item.donationProducts.length === 3
                            ? {
                                float: "left",
                                width: "100%",
                                height: "50%",
                                objectFit: "cover",
                                backgroundColor:
                                  index === 3 &&
                                  item.donationProducts.length > 4
                                    ? "#37B34A"
                                    : "",
                              }
                            : {
                                float: "left",
                                ...DONATION_PRODUCT_WIDTH_HEIGHT,
                                objectFit: "cover",
                                backgroundColor:
                                  index === 3 &&
                                  item.donationProducts.length > 4
                                    ? "#37B34A"
                                    : "",
                              }
                        }
                      />
                    )}
                    {index < 3 && item.donationProducts.length > 4 && (
                      <img
                        src={`/static/products/${p.productId}.jpg`}
                        style={
                          index === 2 && item.donationProducts.length === 3
                            ? {
                                float: "left",
                                width: "100%",
                                height: "50%",
                                objectFit: "cover",
                                backgroundColor:
                                  index === 3 &&
                                  item.donationProducts.length > 4
                                    ? "#37B34A"
                                    : "",
                              }
                            : {
                                float: "left",
                                ...DONATION_PRODUCT_WIDTH_HEIGHT,
                                objectFit: "cover",
                                backgroundColor:
                                  index === 3 &&
                                  item.donationProducts.length > 4
                                    ? "#37B34A"
                                    : "",
                              }
                        }
                      />
                    )}
                    {index === 3 && item.donationProducts.length > 4 && (
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{
                          position: "absolute",
                          top: "50%;",
                          left: "50%",
                          ...DONATION_PRODUCT_WIDTH_HEIGHT,
                          backgroundColor: "#37B34A",
                          color: "white",
                          p:1
                        }}
                      >
                        +{item.donationProducts.length - 3}
                      </Typography>
                    )}
                  </React.Fragment>
                );
              })}
            {item.donationProducts.length === 0 && (
              <img
                src={`/static/dashboard/oranges.svg`}
                style={{
                  float: "left",
                  ...DONATION_PRODUCT_WIDTH_HEIGHT,
                  objectFit: "cover",
                }}
              ></img>
            )}
          </Box>
          <Box
            component="div"
            sx={{ display: "flex", flexDirection: "column", px: 1 }}
          >
            <Typography
              fontSize={"large"}
              fontWeight={600}
              textTransform={"uppercase"}
              fontFamily={"Poppins"}
            >
              {new Date(item.donation.createdDate).getFullYear()}
              {item.donation.id}{" "}
              {/* {item.donation.donationId.slice(0, 1) +
              item.donation.donationId.slice(10, 14)}{" "} */}
              <Typography
                display={"inline"}
                fontSize={"small"}
                fontFamily={"Poppins"}
                textTransform={"capitalize"}
                component="span"
                color={"#6E6E6E"}
              >
                {new Date(item.donation.createdDate).toLocaleDateString(
                  "pt"
                  // "en-PR",
                  // dateOptions
                )}
              </Typography>
            </Typography>
            <Typography
              fontSize={"small"}
              fontWeight={600}
              textTransform={"capitalize"}
              fontFamily={"Poppins"}
            >
              {t("noOfReservation")}
              <Typography
                display={"inline"}
                fontSize={"small"}
                fontFamily={"Poppins"}
                textTransform={"capitalize"}
                component="span"
                color={"#6E6E6E"}
                ml={2}
              >
                {item.collectionCount}
              </Typography>
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {myCategory?.slice(0, 2).map((cat, index) => (
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                  label={t(cat)}
                  size={"medium"}
                  component="div"
                  key={index}
                />
              ))}
              {myCategory !== undefined && myCategory.length > 2 && (
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                  label={`+${myCategory.length - 2}`}
                  size={"medium"}
                />
              )}
            </Box>
          </Box>
        </Box>
        <Button
          sx={{
            bgcolor: "#E1EFB0",
            width: "36px",
            height: "36px",
            minWidth: 0,
            borderRadius:'4px'
          }}
          size="small"
          onClick={handleClick}
        >
          <SvgIconStyle
            src="/static/dashboard/info.svg"
            sx={{ color: "black", width: "16px", height: "16px" }}
          />
        </Button>
      </Paper>
      <DonationDrawer
        drawerState={drawerState}
        toggleDrawer={toggleDrawer}
        donationDetail={item}
        t={t}
        component={component}
      />
    </>
  );
};

export default DonationList;
